<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-solid fa-graduation-cap" aria-hidden="true" style="font-size: 20px; margin-right: 3px; color: var(--iq-primary);"></i>
              {{cvCardTitle}}
            </h4>
            <span v-if="userDetails">
              <b>Student Name:</b>&nbsp;<span class="primary-color" @click="gotoUserProfile(userDetails?.user_id)">{{userDetails?.user_name}}</span><br>
              <span v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><b>Student Id:</b>&nbsp;<span class="primary-color" @click="gotoUserProfile(userDetails?.user_id)">{{userDetails?.user_id}}</span></span>
            </span>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <!-- This button gets enabled, when there are more batches that the user has not purchased, commenting this one as its causing lot of confusion -->
            <!-- <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToTestPrepPdtPage" v-if="moreBatchesToBuy && userData?.user_role == 'USERROLE11114'">{{cvbtnGidePrep}}</b-button> -->
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToGIDEPrepDashboard" v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'">{{cvbtnGIDEPrepDashboard}}</b-button>
            <!-- target score modal -->
            <TargetScoreModal
              v-if="VUE_APP_ENV !== 'prod'"
              :propUserId="gide_user_id"
              :propInterestId="interestId"
              :propTprepId="tPrepObj ? tPrepObj.tprep_id : null"
            />
          </div>
        </div>

        <div class="iq-card p-3">
          <b-row>
            <b-col class="col-12 col-md-6 mb-3">
              <b-form-input
                id="search"
                v-model="filter"
                type="search"
                :placeholder="cvSearchText"
              ></b-form-input>
            </b-col>
            <b-col class="col-12 col-md-6 mb-3" v-if="Object.keys(categorizedFilters).length > 1">
              <div class="d-flex flex-wrap pull-right">
                <b-badge
                  v-for="(subCategory, index) in Object.keys(categorizedFilters)"
                  :key="index"
                  variant="none"
                  :class="['subcat-badge', { 'selected-badge': selectedSubCategory === subCategory }]"
                  :style="getSubCategoryBadgeStyle(subCategory)"
                  @click="selectedSubCategory = subCategory"
                >
                  {{ subCategory }}
                </b-badge>
              </div>
            </b-col>
          </b-row>
        </div>

        <!-- Badges -->
        <div class="iq-card row p-3" v-if="Object.keys(filteredAnalytics).length > 1">
          <div :key="refreshTheFilterBadges" class="mt-2">
            <b-badge
              v-for="(subjectModuleListAnalyticsObj, index) of filteredAnalytics"
              :key="index + (subjectModuleListAnalyticsObj.interest_id || index)"
              title="Show active questions only"
              :style="setTagStyles(subjectModuleListAnalyticsObj.interest_id, subjectModuleListAnalyticsObj.interest_color_code)"
              class="tags mr-2 mb-2 font-weight-normal"
              variant="none"
              @click="filterTestSeriesModules(subjectModuleListAnalyticsObj.interest_id)"
            >
              <span>{{ subjectModuleListAnalyticsObj.subject_name }}:&nbsp; {{ subjectModuleListAnalyticsObj.module_count }} </span>
            </b-badge>
          </div>
        </div>

        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="subjModuleListObj && subjModuleListObj.length > 0" :key="currentBatchNo">
              <b-table
                hover
                responsive
                :items="subjModuleListObj"
                :fields="columns"
                :no-border-collapse="true"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :current-page="currentBatchNo"
                :per-page="dataPerPage"
              >
                <template v-slot:cell(id)="data">
                  <span>{{subjModuleListObj.indexOf(data.item)+1}}</span>
                </template>

                <template v-slot:cell(subject_module_name)="data">
                  <span>
                    <span>{{ fixTestName(data.item) }}</span><br>
                    <small v-if="userData?.user_role == 'USERROLE11111' || userData?.user_role == 'USERROLE11118'">Id: {{data.item.app_id}}<br></small>
                  <!-- <b-badge class="ml-1" size="sm" :style="getStateColorCode(data.item.interest_color_code)">{{data.item.subject_name }}</b-badge><br> -->
                  </span><br>
                <b-button variant="mr-1" title="Add / Edit Tutorial" @click="blogAdd(data.item)" v-if="!data.item.blog_id && (userData?.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')"><i class="fa-solid fa-edit font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="View Tutorial" @click="showblogViewDialog(data.item)" v-if="data.item.blog_id"><i class="fa-solid fa-book-open-reader font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="Take Assessment" @click="goToAppDetail(data.item.app_id)" v-if="data.item.app_id && gide_user_id && userData.user_id == gide_user_id"><i class="fa-solid fa-play font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="View Attempts" @click="goToAttemptList(data.item.app_id)" v-if="data.item.app_id" :disabled="data.item.no_of_attempts <= 0"><i class="fa-solid fa-square-poll-vertical font-size-20"></i></b-button>
                  <b-button variant="mr-1" title="View, Debug & Fix Duplicate Assessment" @click="fixDuplicateResults(data.item.app_id, gide_user_id)" :disabled="data.item.no_of_attempts <= 0" v-if="userData?.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'"><i class="fa-solid fa-bug font-size-20"></i></b-button>
                </template>

              <!-- TestSeries Extra Columns -->
              <template v-slot:cell(app_duration)="data">
                <span v-if="data.item.app_duration">
                  <i class="fa-solid fa-hourglass-end font-size-20"></i>&nbsp;&nbsp;{{ data.item.app_duration/60 }}&nbsp;Mins
                </span>
                <span>
                  <i class="fa-solid fa-hourglass-end font-size-20"></i> {{ selectedExam.exam_total_time }} mins
                </span>
              </template>

              <template v-slot:cell(exam_total_time)="data">
                <span v-if="data.item && data.item.app_duration">
                  {{ (data.item.app_duration / 60).toFixed(0) }} Mins
                </span>
                <span v-else>
                  {{ selectedExam.exam_total_time }} Mins
                </span>
              </template>

              <template v-slot:cell(exam_total_question)="data">
                <span v-if="data.item && data.item.app_total_questions">
                  {{ data.item.app_total_questions }}
                </span>
                <span v-else>
                  {{ selectedExam.exam_total_question }}
                </span>
              </template>

              <template v-slot:cell(app_total_score)="data">
                <span v-if="data.item && data.item.app_total_score != null && data.item && data.item.app_total_score !== 0">
                  {{ data.item.app_total_score }}
                </span>
                <span v-else>
                  {{ selectedExam.app_total_score }}
                </span>
              </template>

              <!-- Created On -->
              <template v-slot:cell(created_on)="data">
                <span v-if="data.item.created_on == '-'">&#8212;</span>
                <span v-else>{{data.item.created_on | dateFormatDDMMMYYYYHHMMA}}</span>
              </template>

              <!-- <template v-slot:cell(avg_score_percentage)="data">
                <span>{{data.item.avg_score_percentage ? data.item.avg_score_percentage.toFixed(2) : "0"}}%</span>
              </template> -->
              </b-table>
            </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found. Subject Practice, Mocks etc not allocated. Please contact your trainer for allocation.
          </b-col>

          <!-- NOT WORKING
          <b-col sm="7" md="8" class="my-1">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="4" class="my-1">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col> -->
        </div>
      </b-col>
    </b-row>

    <!-- Gide Blog Add -->
    <b-modal
      v-model="showModelblogAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <blogAdd :propOpenedInModal="true" :propBlogId="app_id" @emitCloseblogAddModal="closeblogAddModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeblogAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- Gide Blog Add -->

    <!-- Student Counsellor Form V1 -->
    <b-modal
      v-model="showCounsellingQuizModalv1"
      scrollable
      :title="cvSpcmSpcmCounsellorFormTitle"
      size="xxl"
      hide-footer
    >
      <PAQ :propQuestionObj="questionObj" :propParentModuleObj="tPrepObj" :propContractId="contractId" @emitClosePreCounsellingQuizModal="closeCounsellingQuizModal" @emitContractTnCAccept="contractTnCAccept"/>/>
    </b-modal><!--Student Counsellor Form V1 -->

    <!-- Gide Contract -->
    <b-modal
      v-model="showModalGideContracts"
      scrollable
      size="xxl"
      title="GIDE TestPrep Contract"
      hide-footer
    >
      <GideContract :propOpenedInModal="true" :propGideContractObj="gideContractObj" :propContractId="contractId" @emitcloseGIDECounselingContractModal="closeGIDECounselingContractModal" @emitContractTnCAccept="contractTnCAccept"/>
    </b-modal><!-- Gide Contract -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>

    <!-- Gide Blog View -->
    <b-modal scrollable :title="cvViewModalHeader" size="xxl">
      <gideBlogView :propOpenedInModal="true" :propBlogVueObj="blogViewObj"/>
    </b-modal>
  </b-container>
</template>

<script>
import { TPrepSubjectModules } from "../../../FackApi/api/TPrepSubjectModule"
import { socialvue } from "../../../config/pluginInit"
import TestSeriesConfigJson from "../../../FackApi/json/TestSeries.json"
import gideBlogView from "../../Public/GideBlogView.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import blogAdd from "../Blog/blogAdd.vue"
import { AppResults } from "../../../FackApi/api/appResults.js"
import QuizType from "../../../FackApi/json/QuizType.js"
import PAQ from "../SPCM/PAQ.vue"
import { TprepSessions } from "../../../FackApi/api/TprepSession.js"
import GideContract from "../SPCM/GideContract.vue"
import TargetScoreModal from "../../../components/TargetScoreModal.vue"

export default {
  name: "TPrepModuleList",
  components: {
    GideContract,
    gideBlogView,
    blogAdd,
    PAQ,
    TargetScoreModal
  },
  data () {
    return {
      TestSeriesConfigJson: TestSeriesConfigJson,
      apiName: "tprep_subject_module_report_list",
      subjectId: null,
      subjModuleListObj: [],
      subjectModuleResultListRespObj: [],
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Test Name", key: "subject_module_name", class: "text-left align-text-top", sortable: true },
        { label: "Attempts", key: "no_of_attempts", class: "text-left align-text-top", sortable: true },
        // { label: "Questions", key: "exam_total_question", class: "text-left align-text-top" },
        // { label: "Score", key: "app_total_score", class: "text-left align-text-top" },
        // { label: "Duration (mins)", key: "exam_total_time", class: "text-left align-text-top" }
        { label: "Quiz Date", key: "created_on", class: "text-left align-text-top w-200px", sortable: true }
      ],
      testseriesExamData: {
        clat: { exam_total_time: "120", exam_total_question: "120", app_total_score: "120" },
        sat: { exam_total_time: "120", exam_total_question: "120", app_total_score: "120" },
        cuet: { exam_total_time: "120", exam_total_question: "120", app_total_score: "120" },
        gre: { exam_total_time: "120", exam_total_question: "120", app_total_score: "120" }
      },
      cvSearchText: "Type to Search",
      filter: null,
      filterOn: [],
      totalRows: 1,
      dataPerPage: 100,
      cvCardTitle: `Testprep Dashboard - ${this.$route.params.subjId.split("TESTSERIES_")[1].split("_MOCK")[0]} `,
      sortBy: "name",
      sortDesc: false,
      userDetails: null,
      cvbtnGidePrep: "Add",
      cvbtnGIDEPrepDashboard: "Testprep Admin Dashboard",
      showModelblogView: false,
      blogViewObj: null,
      cvViewModalHeader: "Testprep",
      cvbtnModalCancel: "Close",
      moreBatchesToBuy: true,
      userSubjectInterest: null,
      gide_user_id: null,
      subjectModuleListAnalyticsObjList: [],
      subjectModuleFilterMap: {}, // indicated currently active filters
      whereFilter: {
        interest_id: this.$route.params.subjId,
        exam_name: TestSeriesConfigJson.SUPPORTED_EXAMS.find(e => e.interest_id == this.$route.params.subjId).subject.replaceAll("-", "_"),
        testseries_module_type: "ALL"
      },
      exam_type: "mock", // mock, drill, practice, sectional
      refreshTheFilterBadges: 0,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Testprep Exam List",
      currentBatchNo: 1,
      totalDataCount: null,
      fetchTotalDataCount: true,
      showLoadMoreBtn: true,
      cvAddModalHeader: "Add Blog",
      showModelblogAdd: false,
      app_id: null,
      selectedSubCategory: null,
      categorizedFilters: {},
      QuizType: QuizType,
      cvSpcmSpcmCounsellorFormTitle: "Student Onboarding Form",
      showCounsellingQuizModalv1: false,
      questionObj: null,
      interestId: null,
      tPrepObj: null,
      showModalGideContracts: false,
      gideContractObj: null,
      contractId: "BLOGGIDEPREPContractGIDEPREPId0002",
      VUE_APP_ENV: process.env.VUE_APP_ENV
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    filteredAnalytics () {
      if (!this.selectedSubCategory || !this.categorizedFilters[this.selectedSubCategory]) {
        return this.subjectModuleListAnalyticsObjList
      }
      return this.categorizedFilters[this.selectedSubCategory]
    },
    selectedExam () {
      const id = this.$route.query.gide_user_id || ""
      if (id.includes("clat")) return this.testseriesExamData.clat
      if (id.includes("sat")) return this.testseriesExamData.sat
      if (id.includes("cuet")) return this.testseriesExamData.cuet
      if (id.includes("gre")) return this.testseriesExamData.gre
      return this.testseriesExamData.clat
    }
  },
  watch: {
    categorizedFilters: {
      immediate: true,
      handler (newVal) {
        const subKeys = Object.keys(newVal || {})
        if (subKeys.length) this.selectedSubCategory = subKeys[0]
      }
    },
    filteredAnalytics: {
      immediate: true,
      handler (newVal) {
        if (!newVal) return
        const first = Array.isArray(newVal) && newVal.length ? newVal[0] : typeof newVal === "object" ? Object.values(newVal).flat()[0] : null
        if (first?.interest_id) this.filterTestSeriesModules(first.interest_id)
      }
    }
  },
  async mounted () {
    socialvue.index()
    this.gide_user_id = this.$route.query.gide_user_id ? this.$route.query.gide_user_id : this.userData.user_id
    this.interestId = this.$route?.params?.subjId

    this.launchPAQContract()

    this.subjectModuleListAnalyticsObjList = await this.getModuleListAnalytics()
  },
  methods: {
    /**
     * launch PAQ Contract
     */
    async launchPAQContract () {
      this.tPrepObj = await this.tprepSubjectModuleDistincte("tprep_tnc, tprep_id")
      if (!this.tPrepObj) {
        // if tPrepObj is NULL or {} means user has done B2C Payment with pay_tid & aff_code starting with "pay_"
        // In such a scenario dont launch the PAQ or GIDEContract
        return
      }
      this.tPrepObj.parent_module_name = "TPREP"

      // Check Contract Form is submitted or not
      if (!(this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118") && !this.tPrepObj?.tprep_tnc) {
        let golive = 1
        if (golive == 1) {
          // Open the PAQ in a Modal Box if the Contract is not accepted by Student/Parent
          this.questionObj = {
            app_id: "PRE_COUNSELING_APP_ID",
            user_id: this.gide_user_id,
            tnc_flag: this.tPrepObj.spcm_tnc
          }

          this.showCounsellingQuizModalv1 = true
        }
        else {
          // Open the Contract in a Modal Box if the Contract is not accepted by Student/Parent
          this.viewContract(this.tPrepObj)
        }
      }
    },
    /**
     * goto User Profile
     */
    gotoUserProfile (UserId) {
      window.open(`/user/${UserId}`)
    },
    /**
     * load More Data
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.getModuleList(true)
    },
    /**
     * getModuleList
     */
    async getModuleList (loadViaLoadMore = false) {
      try {
        let payload = {}

        if (this.$route.query.gide_user_id) {
          payload.gide_user_id = this.$route.query.gide_user_id
        }
        else {
          payload.gide_user_id = this.userData.user_id
        }

        // setting data for pagination
        payload.filter = {
          currentBatchNo: this.currentBatchNo,
          dataPerPage: this.dataPerPage,
          fetchTotalDataCount: this.fetchTotalDataCount,
          ...this.whereFilter
        }

        payload.exam_type = this.exam_type // practice, exam, etc

        const subjectModuleListResp = await TPrepSubjectModules.tprepSubjectModuleReportList(this, payload)

        this.userDetails = subjectModuleListResp?.user_details ? subjectModuleListResp.user_details : { user_id: "-", user_name: "-" }

        if (subjectModuleListResp && subjectModuleListResp.resp_status) {
          let attemptsData
          if (!loadViaLoadMore) {
            this.subjModuleListObj = [ ...subjectModuleListResp.resp_data.data ]
          }
          else {
            this.subjModuleListObj = [...this.subjModuleListObj, ...subjectModuleListResp.resp_data.data]
          }

          if (subjectModuleListResp.resp_data_total_count) {
            this.totalDataCount = subjectModuleListResp.resp_data_total_count
          }

          attemptsData = subjectModuleListResp.attempts_data
          if (attemptsData) {
            for (let subjectModule of this.subjModuleListObj) {
              let attempts = attemptsData.find(e => e.app_id == subjectModule.app_id)
              if (attempts) {
                subjectModule.no_of_attempts = attempts.no_of_attempts
                subjectModule.avg_score_percentage = attempts.avg_score_percentage
                subjectModule.created_on = attempts.created_on
              }
              else {
                subjectModule.no_of_attempts = 0
                subjectModule.avg_score_percentage = 0
                subjectModule.created_on = "-"
              }
            }
          }

          // Sort on attempt count in desc order
          // this.subjModuleListObj.sort((a, b) => b.no_of_attempts - a.no_of_attempts)

          // Sort on created_on in desc order
          this.subjModuleListObj.sort((a, b) => a.created_on && b.created_on ? b.created_on.localeCompare(a.created_on) : "-")

          this.showLoadMoreBtn = !(this.subjModuleListObj.length === this.totalDataCount)

          this.subjModuleListObj.forEach((s, index) => {
            s.id = (this.currentBatchNo - 1) * this.dataPerPage + index + 1
          })

          // Adding the serial numbers:
          this.totalRows = this.subjModuleListObj.length
          this.currentBatchNo = this.totalRows / this.dataPerPage
          this.fetchTotalDataCount = false
        }
        else {
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = subjectModuleListResp.resp_msg
          ApiResponse.responseMessageDisplay(this, subjectModuleListResp)
        }
      }
      catch (err) {
        console.error("Exception in getModuleList and err: ", err)
      }
    },

    /**
     * getModuleListAnalytics
     */
    async getModuleListAnalytics () {
      try {
        let payload = {}

        payload.exam_type = this.exam_type // practice, exam, etc

        if (this.$route.query.gide_user_id) {
          payload.gide_user_id = this.$route.query.gide_user_id
        }
        else {
          payload.gide_user_id = this.userData.user_id
        }

        payload.filter = this.whereFilter

        const subjectModuleListAnalyticsResp = await TPrepSubjectModules.tprepSubjectModuleReportListAnalytics(this, payload)
        if (!subjectModuleListAnalyticsResp.resp_status) {
          if (subjectModuleListAnalyticsResp.resp_code == "ERR_EXAM_SUBSCRIPTION_NOT_FOUND") {
            // this.$router.push(`/testseries_product_list`)
            console.error("ERR_EXAM_SUBSCRIPTION_NOT_FOUND")
          }

          return
        }

        this.subjectModuleListAnalyticsObjList = subjectModuleListAnalyticsResp.resp_data.data || []

        // categorize analytics data into groups
        this.categorizedFilters = this.categorizeFilters(this.subjectModuleListAnalyticsObjList)
        const subKeys = Object.keys(this.categorizedFilters)
        this.selectedSubCategory = subKeys.length ? subKeys[0] : null

        return this.subjectModuleListAnalyticsObjList
      }
      catch (err) {
        console.error("Exception in getModuleListAnalytics and err: ", err)
      }
    },

    /**
     * categorizeFilters - groups analytics into subcategories
     */
    categorizeFilters (dataList) {
      const subs = {}

      for (const obj of dataList) {
        const id = (obj.interest_id || "").toString().toUpperCase()

        let sub = "GENERAL"
        if (id.includes("PRACTICE")) sub = "PRACTICE"
        else if (id.includes("MOCK")) sub = "MOCK"
        else if (id.includes("DRILL")) sub = "DRILL"
        else if (id.includes("SECTIONAL")) sub = "SECTIONAL TEST"

        if (!subs[sub]) subs[sub] = []
        subs[sub].push(obj)
      }

      return subs
    },
    /**
     * createAppResult
     * When "quiz_bank_list" api is called from the first member of the chain, it inserts blank results in "apps_results_all" & "apps_results", we display the attempt using entries from "apps_results_all" so call this api to get the results inserted
     */
    async createAppResult (appId) {
      try {
        let payload = {
          app_id: appId,
          app_type: this.QuizType["TEST_PREP"]
        }

        if (this.$route.params.subjId.toLowerCase().includes("sat")) {
          payload.tprep_test_name = "sat"
        }

        if (this.$route.params.subjId.toLowerCase().includes("clat")) {
          payload.tprep_test_name = "clat"
        }

        const appsResultsSessionCreateResp = await AppResults.appsResultsSessionCreate(this, payload)
        if (!appsResultsSessionCreateResp.resp_status) {
          return false
        }

        return appsResultsSessionCreateResp
      }
      catch (error) {
        console.error("Exception in createAppResult and err: ", error)
        this.chainedApps = []
        this.showToast = true
        this.toastMsg = "An error occurred while fetching your selected subjects. Please try again later."
        this.toastVariant = "danger"
        return false
      }
    },
    /**
     * goTo Quiz/App Details
     */
    async goToAppDetail (appId) {
      this.goToAttemptList(appId)
      /*
      // Below code commented as the same action we are doing on START NOW QUIZ - TOBEDEPRECATED BY 30 Aug 2026 if all working fine
      const sessionCreateResp = await this.createAppResult(appId)
      if (sessionCreateResp.resp_status) {
        if (sessionCreateResp.resp_code == "INPROGRESS_QUIZ") {
          this.goToAttemptList(appId)
        }
        else {
          this.$router.push(`/quiz_detail/${appId}?module=testseries`)
        }
      }
      */
    },
    /**
     * goTo Quiz/App Attempt List
     */
    goToAttemptList (appId) {
      const query = {}

      if (this.$route.query.gide_user_id) {
        query.gide_user_id = this.$route.query.gide_user_id
      }

      if (appId) {
        this.$router.push({ path: `/attempt_list/${appId}/${appId}`, query })
      }
    },
    /**
     * goToTestPrepPdtPage
     */
    goToTestPrepPdtPage () {
      this.$router.push(`/testseries_exam_details/${TestSeriesConfigJson.TESTSERIES_SAT_PRODUCT_PAGE_APP_ID}`)
    },
    /**
     * goToGIDEPrepDashboard
     */
    goToGIDEPrepDashboard () {
      this.$router.push("/testseries_admin_dashboard")
    },
    /**
     * getResultAnalysis
     */
    async getResultAnalysis (result) {
      this.$router.push(`/app_result_analyse/${result.app_id}/${this.gide_user_id}`)
    },
    /**
     * get State ColorCode
     */
    getStateColorCode (color) {
      return `vertical-align: middle; color: #FFF; background: ${color} !important;`
    },
    /**
     * setTagStyles
     */
    setTagStyles (interestId) {
      let styles = "cursor:pointer;font-size:1rem;"
      if (this.subjectModuleFilterMap[interestId] == 1) {
        // Filter is selected so set a solid background with white text
        styles += `background-color:#e5252c;color:#fff;`
      }
      else {
        styles += `border:1px solid #000; color:#000;`
      }
      return styles
    },
    /**
     * show blog View Dialog
     */
    showblogViewDialog (item) {
      try {
        window.open(`/blog_view/${item.blog_id}`, "_blank")
      }
      catch (err) {
        console.error("Exception occurred at showblogViewDialog() and Exception:", err.message)
      }
    },
    /**
     * filterTestSeriesModules
     */
    filterTestSeriesModules (interestId) {
      this.currentBatchNo = 1
      this.fetchTotalDataCount = true

      this.subjectModuleListAnalyticsObjList.forEach((e) => {
        this.subjectModuleFilterMap[e.interest_id] = 0 // unset all the filters
      })

      // Set the clicked filter
      this.subjectModuleFilterMap[interestId] = 1
      this.refreshTheFilterBadges += 1

      // Apply filter with clicked interestId
      this.whereFilter.testseries_module_type = interestId

      interestId = interestId.toLowerCase()
      if (interestId.includes("sectional")) {
        this.exam_type = "sectional"
      }
      else if (interestId.includes("mock")) {
        this.exam_type = "mock"
      }
      else if (interestId.includes("drill")) {
        this.exam_type = "drill"
      }
      else {
        this.exam_type = "practice"
      }

      this.getModuleList()
    },
    /**
     * fixDuplicateResults
     */
    fixDuplicateResults (appId, userId) {
      try {
        this.$router.push(`/appResult_list_fix/${appId}/${userId}`)
      }
      catch (err) {
        console.error("Exception in fixDuplicateResults and err: ", err)
      }
    },
    /**
     * blog Add
     */
    blogAdd (appData) {
      this.app_id = appData.app_id
      this.showModelblogAdd = true
    },
    /**
     * close blog Add Modal
     */
    closeblogAddModal (blogAddData) {
      this.showModelblogAdd = false
      this.getModuleList()
    },
    /**
     * Remove data after color : and return
     */
    fixTestName (item) {
      let name = item.subject_module_name ? item.subject_module_name.toLowerCase() : ""
      if (name.includes("mock") || name.includes("sectional")) {
        return item.subject_module_name.split(":")[0]
      }
      else {
        return item.app_name_alias
      }
    },
    /**
     * get SubCategory BadgeStyle
     */
    getSubCategoryBadgeStyle (subCategory) {
      if (this.selectedSubCategory === subCategory) {
        // selected badge: solid color, white text
        return {
          backgroundColor: "#e5252c",
          color: "#fff",
          border: `1px solid #e5252c`
        }
      }
      else {
        // unselected badge: border color only
        return {
          backgroundColor: "transparent",
          color: "#000",
          border: `1px solid #000`
        }
      }
    },
    /**
     * close PreCounselling Quiz Modal
     */
    closeCounsellingQuizModal () {
      this.showCounsellingQuizModalv1 = false
    },
    /*
     * tprepSubjectModuleDistincte
     */
    async tprepSubjectModuleDistincte (filterName = null) {
      try {
        let subModuleFilterListResp = await TPrepSubjectModules.tprepSubjectModuleDistincte(this, filterName, this.gide_user_id)
        if (subModuleFilterListResp?.resp_status) {
          this.tPrepObj = subModuleFilterListResp.resp_data[0]
        }
      }
      catch (err) {
        console.error("Exception occurred at tprep_subject_module_distincte() and Exception:", err.message)
      }

      return this.tPrepObj
    },
    /**
     * view Gide contracts
     */
    viewContract (tPrepObj) {
      this.gideContractObj = tPrepObj
      this.gideContractObj.tnc_flag = tPrepObj?.tprep_tnc ? tPrepObj.tprep_tnc : 0
      // this.gideContractObj.contract_attached_file = tPrepObj.spcm_contract // Not Applicable
      this.gideContractObj.blog_id = this.contractId
      this.showModalGideContracts = true
    },
    /**
     * close GIDECounselingContractModal
     */
    async closeGIDECounselingContractModal () {
      this.tPrepObj = await this.tprepSubjectModuleDistincte("tprep_tnc, tprep_id")
      this.tPrepObj.parent_module_name = "TPREP"
      this.subjectModuleListAnalyticsObjList = await this.getModuleListAnalytics()
      this.showModalGideContracts = false
      this.showCounsellingQuizModalv1 = false
    },
    /**
     * GIDEPrep TnC Accept
     */
    async contractTnCAccept () {
      let payload = {
        tprep_id: this.tPrepObj.tprep_id,
        tprep_tnc: 1
      }

      TprepSessions.tprep_contract_update(this, payload)

      this.closeGIDECounselingContractModal()
    }
  }
}
</script>

<style>
.w-full{
  width: 100%;
}
.tags {
  padding: 6px 10px;
  border-radius: 8px;
  display: inline-block;
}
</style>
